










































































































import { walletStore } from '@/stores/wallet-store'
import { Observer } from 'mobx-vue'
import { Component, Inject, Ref, Vue } from 'vue-property-decorator'
import { SbStakingViewModel } from '../viewmodel/sb-staking-viewmodel'

@Observer
@Component({
  components: {}
})
export default class extends Vue {
  @Inject() vm!: SbStakingViewModel
  @Ref('unstake-dialog') unstakeDialog: any

  wallet = walletStore
}
